import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import styles from './styles.module.css';
import { GroupedSelectDesktopOptions } from '../GroupedSelectDesktopOptions';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function GroupedSelectDesktopDropdown(props) {
  const {
    open,
    value,
    groups,
    focusedIndex,
    actions,
    onKeyDown,
    insideRefs,
    dataTestId
  } = props;
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['list'],
      role: "listbox",
      onKeyDown: onKeyDown,
      "data-testid": generateDataTestId(dataTestId, ['dropdown']),
      children: groups.map((group, index) => {
        const {
          key,
          label,
          leftAdornment,
          options,
          dataTestId
        } = group;
        const defaultTestId = generateDataTestId('group', [key]);
        const testId = dataTestId || defaultTestId;
        return /*#__PURE__*/_jsxs("div", {
          className: styles['group-wrapper'],
          "data-testid": testId,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['group-label'],
            children: /*#__PURE__*/_jsxs("div", {
              className: styles['group'],
              children: [!!leftAdornment && /*#__PURE__*/_jsx("div", {
                className: styles['icon'],
                children: leftAdornment
              }), /*#__PURE__*/_jsx("div", {
                className: styles['label'],
                children: label
              })]
            })
          }), /*#__PURE__*/_jsx(GroupedSelectDesktopOptions, {
            open: open,
            indented: !!leftAdornment,
            groupIndex: index,
            options: options,
            value: value,
            focusedIndex: focusedIndex,
            actions: actions
          })]
        }, key);
      })
    })
  });
}